import styled from "styled-components";
import bg from "../../assets/images/bg_confirm_page.jpg";

export const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding-top: 20px;

    .border {
        border-left: 6px solid;
        border-image: linear-gradient(to top, #0a9e9e 0%, #175D90 59.58%, #733BB9 100%);
        border-image-slice: 1;
    }
`;

export const Row = styled.div`
  background: var(--white);
  -webkit-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  -moz-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  border-radius: 1.5%;
  display: flex;
  align-items: center;
  flex-direction: row;

    .container {
        margin: 50px;
    }
`;

export const Field = styled.span`
  color: #222;
  width: 100%;
  text-align: left;
  font-size: 1em;
  max-width: 650px;
  word-wrap: break-word !important;
`;

export const Align = styled.div`
    width: 100%;
    display: flex;
    p + p {
        margin-left: 10px;
    }
`;

export const LogoName = styled.span`
  font-family: 'Roboto';
  font-size: 26px;
  line-height: 30px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  flex-grow: 1;

  color: #fff;

  opacity: 0.6;
`;

export const Header = styled.div`
  overflow: hidden;
  background: linear-gradient(115.6deg, #0a9e9e 0%, #175D90 59.58%, #733BB9 100%);
  padding: 20px 10px;
`;

export const Body = styled.div`
  overflow: flex;
  background: url(${bg});
  background-size: cover;
  height: 100vh;
`;

export const MapDisplay = styled.div`
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .seat-content {
    overflow-x: scroll;
  }
  .seat-picker__row__number {
    visibility: hidden;
  }
`;